import consts from "@/consts.js";
import Request from './request';

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "shop_code", "shop_name","status"]; //仅筛选少许必要字段
    return Request('get', "api/shops/select", data, false, false, true);
}

export default {
    fetchAllForSelect,
   
};